// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: var(--footer-bg);
  padding-top: 40px;
  border-top: 1px solid var(--footer-border);
}

.footer__container {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 175px 75px 172px 456px;
  padding-bottom: 48px !important;
}

.footer__logo {
  display: flex;
  align-items: flex-start;
}

.footer__logo svg {
  flex-shrink: 0;
}

.footer__logo svg:first-child {
  width: 100px;
  fill: var(--topaz-color);
}

.footer__logo svg:last-child {
  width: 70px;
}

.footer__links ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer__text {
  color: var(--text-color);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 8px;
}

.footer__text--gray {
  color: var(--text-gray);
  font-size: 14px;
  line-height: 22px;
}

.footer__text--gray:hover {
  color: var(--text-color);
}

.footer__contact ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer__contact ul li {
  display: flex;
  gap: 12px;
}

.footer__contact ul li svg {
  fill: var(--text-gray);
}

.footer__contact ul li svg:hover {
  fill: var(--text-color);
}

.footer__contact ul li a {
  display: flex;
  gap: 12px;
}

.footer__contact ul li a:hover svg {
  fill: var(--text-color);
}

.footer__contact ul li a svg {
  fill: var(--text-gray);
}

.footer__contact ul li a svg:hover {
  fill: var(--text-color);
}

.footer__legal-age-inner {
  display: flex;
  gap: 12px;
  margin-bottom: 42px;
}

.footer__legal-age-inner p {
  color: var(--text-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.footer__legal-age-bottom {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footer__legal-age-bottom p {
  color: #999999;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.footer__legal-age-bottom-flex {
  display: flex;
  gap: 32px;
  align-items: center;
}

.footer__bottom {
  padding-block: 8px;
}

.footer__bottom p {
  color: var(--text-gray);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
}

.footer__crocusoft {
  fill: var(--text-color);
}

.footer__usb-white {
  fill: var(--text-color);
}

.footer__usb-black {
  fill: var(--footer-bg);
}

@media only screen and (max-width: 991px) {
  .footer__container {
    grid-template-columns: 75px 172px;
        grid-template-areas: "logo logo" "links contact" "legal legal";
  }
  .footer__logo {
    -ms-grid-row: 1;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
    grid-area: logo;
    margin-bottom: 30px;
  }
  .footer__links {
    -ms-grid-row: 2;
    -ms-grid-column: 1;
    grid-area: links;
  }
  .footer__contact {
    -ms-grid-row: 2;
    -ms-grid-column: 2;
    grid-area: contact;
  }
  .footer__legal-age {
    -ms-grid-row: 3;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
    grid-area: legal;
    margin-top: 58px;
  }
  .footer__legal-age-inner {
    margin-bottom: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.scss","webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,0CAA0C;ACC5C;;ADCE;EAEE,aAAA;EAGD,8BAAA;EAED,6CAAQ;EACN,+BAAa;ACEjB;;AAEA;EDUK,aAAA;EAPU,uBAAK;ACIpB;;AAEA;EDDQ,cAAW;ACInB;;ADCG;EAEG,YAAS;EACT,wBAAsB;ACC5B;;AAEA;EDEE,WAAO;ACAT;;AAEA;EDII,aAAa;EAGJ,sBAAgB;EACvB,SAAS;ACCf;;AAEA;EDLK,wBAKS;EACN,eAAO;EACR,kBAAA;ECEL,gBAAgB;EDEf,iBACG;EACA,kBAAa;ACDnB;;AAEA;EACE,uBAAuB;EDJtB,eACC;EAMI,iBAAa;ACArB;;AAEA;EDTG,wBAUQ;ACCX;;AAEA;EDEW,aAAA;EAKI,sBAAI;EAeV,SAAA;ACbT;;AAEA;EDxBG,aAAA;EA6BS,SAAM;ACAlB;;AD7BG;EAgCW,sBAAM;ACCpB;;ADQI;EACE,uBAAa;ACLnB;;AAEA;EDQQ,aAAO;EACP,SAAS;ACJjB;;AAEA;EDMO,uBAAA;ACJP;;AAEA;EDOM,sBAAsB;ACL5B;;AAEA;EDCK,uBAAO;ACCZ;;AAEA;EAGE,aAAa;EDMT,SAAA;EACE,mBAAa;ACJrB;;AAEA;EACE,wBAAwB;EDQxB,eAAU;EACR,kBAAkB;EAUnB,gBAAA;ECfD,iBAAiB;ADIhB;;ACDH;EDSM,aAAa;EAKjB,sBAAa;EACX,QAAM;ACNV;;ADUI;EACE,cAAM;EACP,eAAA;ECPH,gBAAgB;EDSd,iBAAQ;ACPZ;;AAEA;EAGE,aDWI;ECVJ,SDWI;EAOA,mBAAe;ACdrB;;AAEA;EACE,kBDgBoB;ACftB;;AAEA;EACE,uBDiBG;EAED,eAAA;ECjBF,kBDkBoB;ECjBpB,gBDkBgB;ECjBhB,iBDqBG;EAHC,kBAAA;AChBN;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IAEM,iCAAiC;QACjC,gEAAgE;EACtE;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".footer {\n  background-color: var(--footer-bg);\n  padding-top: 40px;\n  border-top: 1px solid var(--footer-border);\n\n  &__container {\n    display: grid;\n    justify-content: space-between;\n    grid-template-columns: 175px 75px 172px 456px;\n    padding-bottom: 48px !important;\n  }\n\n  &__logo {\n    display: flex;\n    align-items: flex-start;\n\n    svg {\n      flex-shrink: 0;\n\n      &:first-child {\n        width: 100px;\n        fill: var(--topaz-color);\n      }\n\n      &:last-child {\n        width: 70px;\n      }\n    }\n  }\n\n  &__links {\n    ul {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n  }\n\n  &__text {\n    color: var(--text-color);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 28px;\n    margin-bottom: 8px;\n\n    &--gray {\n      color: var(--text-gray);\n      font-size: 14px;\n      line-height: 22px;\n\n      &:hover {\n        color: var(--text-color);\n      }\n    }\n  }\n\n  &__contact {\n    ul {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      li {\n        display: flex;\n        gap: 12px;\n\n        svg {\n          fill: var(--text-gray);\n\n          &:hover {\n            fill: var(--text-color)\n          }\n        }\n\n        a {\n          display: flex;\n          gap: 12px;\n\n          &:hover {\n            svg {\n              fill: var(--text-color)\n            }\n          }\n\n          svg {\n            fill: var(--text-gray);\n\n            &:hover {\n              fill: var(--text-color)\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &__legal-age {\n    &-inner {\n      display: flex;\n      gap: 12px;\n      margin-bottom: 42px;\n\n      p {\n        color: var(--text-color);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 22px;\n      }\n    }\n\n    &-bottom {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      p {\n        color: #999999;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n      }\n\n      &-flex {\n        display: flex;\n        gap: 32px;\n        align-items: center;\n      }\n    }\n  }\n\n  &__bottom {\n    padding-block: 8px;\n\n    p {\n      color: var(--text-gray);\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px;\n      text-align: center;\n    }\n  }\n\n  &__crocusoft {\n    fill: var(--text-color);\n  }\n\n  &__usb {\n    &-white {\n      fill: var(--text-color);\n    }\n\n    &-black {\n      fill: var(--footer-bg);\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .footer {\n    &__container {\n      grid-template-columns: 75px 172px;\n      grid-template-areas:\n              \"logo logo\"\n              \"links contact\"\n              \"legal legal\";\n    }\n\n    &__logo {\n      grid-area: logo;\n      margin-bottom: 30px;\n    }\n\n    &__links {\n      grid-area: links;\n    }\n\n    &__contact {\n      grid-area: contact;\n    }\n\n    &__legal-age {\n      grid-area: legal;\n      margin-top: 58px;\n      &-inner {\n        margin-bottom: 24px;\n      }\n    }\n  }\n}",".footer {\n  background-color: var(--footer-bg);\n  padding-top: 40px;\n  border-top: 1px solid var(--footer-border);\n}\n\n.footer__container {\n  display: -ms-grid;\n  display: grid;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -ms-grid-columns: 175px 75px 172px 456px;\n      grid-template-columns: 175px 75px 172px 456px;\n  padding-bottom: 48px !important;\n}\n\n.footer__logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.footer__logo svg {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n\n.footer__logo svg:first-child {\n  width: 100px;\n  fill: var(--topaz-color);\n}\n\n.footer__logo svg:last-child {\n  width: 70px;\n}\n\n.footer__links ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 16px;\n}\n\n.footer__text {\n  color: var(--text-color);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n  margin-bottom: 8px;\n}\n\n.footer__text--gray {\n  color: var(--text-gray);\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.footer__text--gray:hover {\n  color: var(--text-color);\n}\n\n.footer__contact ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 16px;\n}\n\n.footer__contact ul li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n}\n\n.footer__contact ul li svg {\n  fill: var(--text-gray);\n}\n\n.footer__contact ul li svg:hover {\n  fill: var(--text-color);\n}\n\n.footer__contact ul li a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n}\n\n.footer__contact ul li a:hover svg {\n  fill: var(--text-color);\n}\n\n.footer__contact ul li a svg {\n  fill: var(--text-gray);\n}\n\n.footer__contact ul li a svg:hover {\n  fill: var(--text-color);\n}\n\n.footer__legal-age-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 42px;\n}\n\n.footer__legal-age-inner p {\n  color: var(--text-color);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n}\n\n.footer__legal-age-bottom {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 4px;\n}\n\n.footer__legal-age-bottom p {\n  color: #999999;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.footer__legal-age-bottom-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 32px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.footer__bottom {\n  padding-block: 8px;\n}\n\n.footer__bottom p {\n  color: var(--text-gray);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n}\n\n.footer__crocusoft {\n  fill: var(--text-color);\n}\n\n.footer__usb-white {\n  fill: var(--text-color);\n}\n\n.footer__usb-black {\n  fill: var(--footer-bg);\n}\n\n@media only screen and (max-width: 991px) {\n  .footer__container {\n    -ms-grid-columns: 75px 172px;\n        grid-template-columns: 75px 172px;\n        grid-template-areas: \"logo logo\"\r \"links contact\"\r \"legal legal\";\n  }\n  .footer__logo {\n    -ms-grid-row: 1;\n    -ms-grid-column: 1;\n    -ms-grid-column-span: 2;\n    grid-area: logo;\n    margin-bottom: 30px;\n  }\n  .footer__links {\n    -ms-grid-row: 2;\n    -ms-grid-column: 1;\n    grid-area: links;\n  }\n  .footer__contact {\n    -ms-grid-row: 2;\n    -ms-grid-column: 2;\n    grid-area: contact;\n  }\n  .footer__legal-age {\n    -ms-grid-row: 3;\n    -ms-grid-column: 1;\n    -ms-grid-column-span: 2;\n    grid-area: legal;\n    margin-top: 58px;\n  }\n  .footer__legal-age-inner {\n    margin-bottom: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
